import { publish, PUBSUB_KEYS } from "@/hooks/usePubsub";
import { useStore } from "@/store";

export const formCallback = (connection: any) => {
  connection.on("ReceiveMessage", function (overType: number, message: string, url: string, guid: any, redisId: any) {
    console.log(overType, message, url, guid, redisId);
    const arr = url.split("/");
    const name = arr[arr.length - 1];
    useStore().setLoading(false);
    if (url) {
      // sendFile(name, url);
      publish(PUBSUB_KEYS.FINANCE_URL, { type: overType, url, message, name });
    }
  });
};
